export const configSSO = {
  issuer: 'https://sts-acc.inforius.be',
  postLogoutRedirectUri: 'https://imandat-acc.azureedge.net',
  redirectUri: 'https://imandat-acc.azureedge.net/callback',
  clientId: 'imandat_e1',
  oidc: true,
  userinfoEndpoint: 'https://sts-acc.inforius.be/connect/userinfo',
  useSilentRefresh: true,
  scope: 'openid profile email imandat.e1_api iconnect.api:invite',
  showDebugInformation: false,
  silentRefreshRedirectUri:
    'https://imandat-acc.azureedge.net/silent-renew.html',
  responseType: 'code',
};
